export function normalizarCamposDecimaisConfiguracao(
  configuracao: Record<string, unknown>
): Record<string, unknown> {
  const agrupadores = Array.isArray(configuracao['agrupadores'])
    ? (configuracao['agrupadores'] as Array<Record<string, unknown>>)
    : [];

  if (!agrupadores.length) {
    return configuracao;
  }

  const agrupadoresNormalizados = agrupadores.map((agrupador) => {
    const campos = Array.isArray(agrupador['campos'])
      ? (agrupador['campos'] as Array<Record<string, unknown>>)
      : [];
    return {
      ...agrupador,
      campos: campos.map(normalizarValorCampoAdicionalDecimal)
    };
  });

  return {
    ...configuracao,
    agrupadores: agrupadoresNormalizados
  };
}

export function normalizarValorCampoAdicionalDecimal(
  campo: Record<string, unknown>
): Record<string, unknown> {
  const formato = String(campo['formato'] || '').toUpperCase();
  const valor = campo['valor'];
  const configuracoes = (campo['configuracoes'] as Record<string, unknown> | undefined) || {};
  const maxDecimalCharsRaw = Number(configuracoes['maxDecimalChars']);
  const maxDecimalChars = Number.isFinite(maxDecimalCharsRaw) && maxDecimalCharsRaw >= 0
    ? Math.floor(maxDecimalCharsRaw)
    : null;
  const ehCampoDecimalPorConfiguracao = Object.prototype.hasOwnProperty.call(configuracoes, 'maxDecimalChars');

  if (
    formato === 'DECIMAL' || formato === 'NUMERIC' || formato === 'NUMBER' ||
    (formato === 'TEXT' && ehCampoDecimalPorConfiguracao)
  ) {
    const numeroNormalizado = normalizarValorDecimal(valor, maxDecimalChars);
    return {
      ...campo,
      formato: 'DECIMAL',
      valor: numeroNormalizado !== null && numeroNormalizado !== '' ? Number(numeroNormalizado) : null
    };
  }

  return campo;
}

export function normalizarValorDecimal(valor: unknown, maxDecimalChars: number | null): string | null {
  const raw = String(valor ?? '').trim();
  if (!raw) {
    return null;
  }

  const negativo = raw.startsWith('-');
  const cleaned = raw.replace(/[^\d.,-]/g, '');
  const semSinal = cleaned.replace(/-/g, '');
  if (!semSinal) {
    return null;
  }

  const lastComma = semSinal.lastIndexOf(',');
  const lastDot = semSinal.lastIndexOf('.');
  let separadorDecimal: ',' | '.' | null = null;
  let idxSeparador = -1;

  if (maxDecimalChars !== 0 && (lastComma >= 0 || lastDot >= 0)) {
    if (lastComma >= 0 && lastDot >= 0) {
      separadorDecimal = lastComma > lastDot ? ',' : '.';
      idxSeparador = Math.max(lastComma, lastDot);
    } else {
      const idx = Math.max(lastComma, lastDot);
      const candidato = idx === lastComma ? ',' : '.';
      const casas = contarDigitos(semSinal.slice(idx + 1));
      if (typeof maxDecimalChars === 'number') {
        if (casas > 0 && casas <= maxDecimalChars) {
          separadorDecimal = candidato;
          idxSeparador = idx;
        }
      } else if (casas > 0) {
        separadorDecimal = candidato;
        idxSeparador = idx;
      }
    }
  }

  let inteiro = '';
  let decimal = '';
  if (separadorDecimal && idxSeparador >= 0) {
    inteiro = String(semSinal.slice(0, idxSeparador)).replace(/[^\d]/g, '');
    decimal = String(semSinal.slice(idxSeparador + 1)).replace(/[^\d]/g, '');
  } else {
    inteiro = semSinal.replace(/[^\d]/g, '');
  }

  if (!inteiro && !decimal) {
    return null;
  }

  if (typeof maxDecimalChars === 'number') {
    decimal = decimal.slice(0, maxDecimalChars);
  }

  const sinal = negativo ? '-' : '';
  if (!decimal) {
    return `${sinal}${inteiro}`;
  }
  return `${sinal}${inteiro}.${decimal}`;
}

function contarDigitos(valor: string): number {
  return String(valor || '').replace(/\D/g, '').length;
}
